<template>
  <app-side-menu>
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                placeholder="Item No."
                v-model="value.itemNumber"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                placeholder="Description"
                v-model="value.description"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.category">
                  <option
                    value=""
                    selected>-- Category --</option>
                  <option :value="itemCategoryTypeEnum.CD">CD</option>
                  <option :value="itemCategoryTypeEnum.CRUSH">CRUSH</option>
                  <option :value="itemCategoryTypeEnum.FIBER">FIBER</option>
                  <option :value="itemCategoryTypeEnum.MECH">MECH</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field has-addons">
            <bulma-radio-button
              :native-value="0"
              v-model="value.active">
              <span class="icon is-small">
                <i class="mdi mdi-adjust" />
              </span>
              Both
            </bulma-radio-button>
            <bulma-radio-button
              type="is-success"
              :native-value="1"
              v-model="value.active">
              <span class="icon is-small">
                <i class="mdi mdi-check" />
              </span>
              Active
            </bulma-radio-button>
            <bulma-radio-button
              type="is-danger"
              :native-value="2"
              v-model="value.active">
              <span class="icon is-small">
                <i class="mdi mdi-close" />
              </span>
              In-Active
            </bulma-radio-button>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button
            class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button
            class="button"
            @click="onResetClick">
            <span class="icon">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import { BulmaRadioButton } from '@/components/BulmaRadio'
import { ItemCategoryTypes } from '@/enums'

export default {
  name: 'OtherlabourListSideMenu',
  inject: ['$vv'],
  components: {
    AppSideMenu,
    BulmaRadioButton
  },
  props: {
    filter: null,
    value: null
  },
  data() {
    return {
      selectedActive: 1
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    itemCategoryTypeEnum: function() {
      return ItemCategoryTypes
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    const elements = document.getElementsByClassName('datepicker')
    Array.from(elements).forEach((element, index, array) => {
      const parent = element.parentNode
      // console.log(parent.nodeType, element)
      if (parent.nodeName === 'BODY') {
        parent.removeChild(element)
      }
    })
    // while (elements.length > 0) {
    //   const parent = elements[elements.length - 1].parentNode
    //   console.log(parent, elements[elements.length - 1])
    //   parent.removeChild(elements[elements.length - 1])
    // }
  },
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.$emit('reset')
    }
  }
}
</script>
<style lang="scss" scoped>
@use '@/assets/style/mixins/inputs/placeholder' as *;;
input.uppercase {
  text-transform: uppercase;
  @include reset-placeholder-text-transform;
}
</style>
